import AuthButtonContainer from './AuthButtonContainer';
import { IStoreState } from '../../../modules';
import OobBioAuthChallengeRequest from '../challenge-request/OobBioAuthChallengeRequest';
import { connect } from 'react-redux';
import { faFingerprint } from '@fortawesome/free-solid-svg-icons';

class OobBioAuthAuthButton extends AuthButtonContainer<Props, {}> {
  static icon = faFingerprint
  static authname = "OOB Biometrics"
  static description = "Authenticate via fingerprint or FaceID"
  static authLevel = 850

  static challengeRequestComponent = OobBioAuthChallengeRequest

  get enrolled(): boolean {
    return this.props.authmethods.oobBio.enrolled
  }

  get required(): boolean {
    return this.props.challenge.requiredCredentials.oobBio ? true : false
  }
}

const mapStateToProps = ({ authmethods, challenge }: IStoreState) => ({
  authmethods,
  challenge,
})

interface Props extends ReturnType<typeof mapStateToProps> {
}

export default connect(mapStateToProps)(OobBioAuthAuthButton)